import { Files } from '@yme/assets/icons';
import { FILE_SIZE, BYTES_IN_KILOBYTE, FILE_MIMETYPE_MAPPING } from './constants';
export function getFormattedFileSize(bytes) {
    if (!bytes)
        return '';
    const kilobyte = BYTES_IN_KILOBYTE;
    const megabyte = kilobyte * BYTES_IN_KILOBYTE;
    const gigabyte = megabyte * BYTES_IN_KILOBYTE;
    if (bytes >= 0 && bytes < kilobyte) {
        return `(${bytes}${FILE_SIZE.byte})`;
    }
    if (bytes >= kilobyte && bytes < megabyte) {
        return `(${(bytes / kilobyte).toFixed(0)}${FILE_SIZE.kilobyte})`;
    }
    if (bytes >= megabyte && bytes < gigabyte) {
        return `(${(bytes / megabyte).toFixed(1)}${FILE_SIZE.megabyte})`;
    }
    return `(${(bytes / gigabyte).toFixed(1)}${FILE_SIZE.gigabyte})`;
}
export function getFileIconType(type) {
    return Files[FILE_MIMETYPE_MAPPING[type]];
}
